import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Card = styled.div`
  background: #fff;
  border-radius: 20px;
  border: 1px solid #eeeeee;
`;

export const CardImage = styled.div`
  padding-bottom: 24px;

  img {
    width: 100%;
    height: 188px;
    object-fit: cover;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  ${mediaQuery.desktop`
  img {
    width: 100%;
    height: 188px;
    object-fit: cover;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  `}
`;

export const ProductName = styled.h2`
  margin: 0;
  padding: 0;
  padding-left: 16px;
  color: #003232;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;

  ${mediaQuery.desktop` 
    margin: 0;
    padding: 0;
    padding-left: 16px;
    color: #003232;
    font-size: 20px;
    font-weight: 500;
    text-transform: capitalize;

    `}
`;

export const ProductBody = styled.div`
  margin-top: 12px;

  .description {
    color: #738c8c;
    font-size: 12px;
    font-weight: 400;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const ProductPrice = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: none;
  gap: 10px;
  margin-top: 27px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 27px;
  flex-direction: column;

  ${mediaQuery.desktop`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 0;
  margin-top: 27px;
  padding-left: 16px;
  padding-bottom: 27px;
  
  `}

  .price {
    color: #003232;
    font-size: 16px;
    font-weight: 700;
  }

  .out_stock {
    background: #ffd6d6;
    border-radius: 2px;
    height: 23px;
    padding: 3px 12px;
    color: #eb5757;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    display: grid;
    place-items: center;
  }

  .in_stock {
    background: #84f48f;
    border-radius: 2px;
    height: 23px;
    padding: 3px 12px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    display: grid;
    place-items: center;
  }
`;
